module.exports = __webpack_public_path__ + "img/city-mid.34b99417.svg";